import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NmiPage } from './nmi.page';

const routes: Routes = [
  {
    path: '',
    component: NmiPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class NmiPageRoutingModule {}
